import { atom, onMount, task } from "nanostores";
import Cookies from "universal-cookie";
import { client } from "@/helpers/trpc/trpc-client";

export const isUserLoading = atom(true);
export const user = atom(
  null as Awaited<ReturnType<typeof client.user.getUser.query>> | null
);

onMount(user, () => {
  // eslint-disable-next-line @typescript-eslint/no-floating-promises
  task(async () => {
    try {
      //make sure we have a jwt
      const cookies = new Cookies();
      if (cookies.get("jwt")) {
        user.set(await client.user.getUser.query());
      }
    } catch {}
    isUserLoading.set(false);
  }).catch((err) => console.error(`Couldn't load user: ${err}`));
});
